"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var payment_methods_const_1 = require("./payment-methods.const");
/**
 * PaymentMethodsService
 * @class
 */
var PaymentMethodsService = /** @class */ (function () {
    function PaymentMethodsService() {
    }
    /**
     * Creates a new payment method for a user when `data` (payment method request) object is provided
     * @param userUuid {string},
     * @param data {PayoutPaymentMethodRequest}
     * @returns {Promise<PayoutPaymentMethodResponse>}
     */
    PaymentMethodsService.prototype.postUserPayoutPaymentMethod = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = payment_methods_const_1.PAYMENT_METHODS_ENDPOINT.postUserPayoutPaymentMethod
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Create new payment method for a user when `data` (payment method request) object is provided
     * @param companyUuid {string},
     * @param data {PayoutPaymentMethodRequest}
     * @returns {Promise<PayoutPaymentMethodResponse>}
     */
    PaymentMethodsService.prototype.postCompanyPayoutPaymentMethod = function (companyUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = payment_methods_const_1.PAYMENT_METHODS_ENDPOINT.postCompanyPayoutPaymentMethod
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Get the user payout payment method from the api
     * @param userUuid the user to get the payout method from
     * @returns {Promise<PayoutPaymentMethodResponse>}
     */
    PaymentMethodsService.prototype.getUserPayoutPaymentMethod = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = payment_methods_const_1.PAYMENT_METHODS_ENDPOINT.getUserPayoutPaymentMethod
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return PaymentMethodsService;
}());
/**
 * PaymentMethodsService Class Instance
 * @namespace
 */
exports.paymentMethods = new PaymentMethodsService();
